import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SeatLayout from 'components/SeatLayout';
import { getSharedSeats, saveSharedSeats } from 'services/operations/seatSharing';
import { useSnackbar } from 'notistack';

const SeatSharing = () => {

  const { enqueueSnackbar } = useSnackbar();
  const [searchParams] = useSearchParams();
  const [libraryId] = useState(searchParams?.get('id') || false);
  const [availableSeats, setAvailableSeats] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getSharedSeatsInfo(libraryId);
  }, [libraryId]);

  function getSharedSeatsInfo(libraryId) {
    getSharedSeats({libraryId}).then(({response, error}) => {
      if(response){
        if(Array.isArray(response?.librarySeats) && Array.isArray(response?.sharedSeatIds)){
          const seats = response.librarySeats.map((seat) => ({...seat, booked: response.sharedSeatIds.includes(seat.id)}));
          setAvailableSeats([...seats]);
        }
      }else{
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }
  
  const onSeatSelected = useCallback((seats) => {
    setSelectedSeats(seats);
  },[]);

  function onSubmitClick() {
    if(Array.isArray(selectedSeats)){
      // const data={
      //   seatIds: [...selectedSeats]
      // }
      saveSharedSeats([...selectedSeats],{},libraryId).then(({response, error}) => {
        if(response){
          enqueueSnackbar("Selectes seats have been saved successfully", {variant: 'success'});
          navigate("/operations/revenue-sharing/");
        }else{
          enqueueSnackbar((response?.message || error), {variant: 'error'});
        }
      });
    }else{
      enqueueSnackbar("Please select at least one seat to proceed", {variant: 'error'});
    }
  }
  
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Seat Sharing
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={2} justifyContent="center">
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
            <Typography variant="subtitle1" gutterBottom>
              Select the seats you want us to manage and submit
            </Typography>
            {libraryId && Array.isArray(availableSeats) ? (
              <SeatLayout
                libData={{libraryId}} 
                hideSaveButton={true} 
                availableSeats={availableSeats} 
                onSeatSelectedListener={onSeatSelected}
                selectedSeatLegend="Shared"
                useBackBtn={true}
              />
            ):null}
          </Grid>
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} sx={{mt:1, textAlign: "center"}}justifyContent="center" >
            <Button variant="outlined" color="secondary" sx={{mr: 1.2}} onClick={() => navigate(-1)}>Back</Button>
            <Button variant="contained"  onClick={onSubmitClick}>Submit</Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default SeatSharing;
